const REVIEWS = [
  {
    name: 'Александр, Приютово',
    text: 'Заказывал навес на два автомобиля (машин). Приехали на замер через день, через неделю уже стоял готовый каркас. Аккуратно, ровно, без нареканий. Соседи теперь тоже хотят такой же.',
    object: 'Навес 6×7 м',
  },
  {
    name: 'Елена, Белебей',
    text: 'Хотела беседку с мангальной зоной — сделали всё в одном стиле. Металл покрасили в цвет забора, смотрится как единый ансамбль. Спасибо за качественную работу.',
    object: 'Беседка + мангальная зона',
  },
  {
    name: 'Сергей, Ермекеево',
    text: 'Нужны были откатные ворота с калиткой. Всё рассчитали, привезли, установили за два дня. Автоматику подключили и настроили. Пользуюсь полгода — всё работает отлично.',
    object: 'Ворота откатные + калитка',
  },
  {
    name: 'Марина, Аксаково',
    text: 'Заказывали кованую оградку для могилы. Сделали точно по эскизу, очень достойно выглядит. Цена адекватная, сроки соблюдены. Рекомендую.',
    object: 'Кованая оградка',
  },
];

export default function Reviews() {
  return (
    <section className="py-16 md:py-20 bg-background-50" id="reviews">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Отзывы наших клиентов
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Что говорят люди, которые уже пользуются нашими конструкциями
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {REVIEWS.map((review, idx) => (
            <div
              key={idx}
              className="bg-background-100 border border-background-200/70 rounded-lg p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="w-4 h-4 flex items-center justify-center text-primary-500">
                    <i className="ri-star-fill text-sm"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4 flex-1">
                "{review.text}"
              </p>
              <div className="border-t border-background-200 pt-4">
                <p className="font-heading text-sm font-semibold text-foreground-950">{review.name}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{review.object}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}